// 活動banner(banner 2張pc不輪播, banner 1張皆不輪播)
'use client';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import '../../styles/swipers.scss';
import { EventsSwiperSlide } from './EventSwiperSlide';

export const EventsBanner = ({banners, originLength}) =>{

    const bannerLink = originLength === 1
            ? banners[0]?.actSlug 
                ? '/events/' + banners[0]?.actSlug 
                : banners[0]?.link 
            : null;

    return(
        <section className="w-full max-h-[300px] overflow-hidden mt-[12px] mx-[auto] max-w-[1840px]">
            { originLength === 1
            ?   (
                    <SingleImg
                        banner={banners[0]}
                        link={bannerLink}
                    />
            )
            :   (
                    <Swiper
                        id="events-swiper"
                        className={`w-full h-full overflow-hidden mx-auto max-w-[1200px] flex center-center`}
                        modules={[Autoplay, Navigation]}
                        slidesPerView={1}
                        spaceBetween={10}
                        loop={true}
                        navigation={true}
                        direction={'horizontal'} // 水平方向
                        freeMode={true}
                        autoplay={{
                            delay: 4000,
                            disableOnInteraction: true,
                        }}
                        breakpoints={{
                            // when window width is >= 280,
                            768: {
                                slidesPerView: 1,
                                autoplay: true,
                            },
                            769: {
                                slidesPerView: 1,
                                autoplay: false,
                            },
                            900: {
                                slidesPerView: 2,
                                spaceBetween: 20,
                                autoplay: false,
                            },
                        }}
                    >
                        {banners.map((banner, i) => {
                            const link = banner?.actSlug ? '/events/' + banner?.actSlug : banner?.link;
                            return (
                                <SwiperSlide key={`banner_${i}`}>
                                    <EventsSwiperSlide
                                        banner={banner}
                                        link={link}
                                    />
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                )
            }
        </section>
    )
};

const SingleImg = ({banner, link}) => {
    return(
        <div className='w-[600px] h-[300px] mx-auto usm:w-full usm:h-[48vw]'>
            <EventsSwiperSlide
                banner={banner}
                link={link}
            />
        </div>
    )
}